<template>
  <page-list
    :list="list"
    :columns="columns" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'AccountManagerList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_accounts',
        filterOptions: {
          name: {
            label: this.$t('scope.text_419'),
            filter: true,
            formatter: val => {
              return `name.contains(${val})`
            },
          },
        },
        getParams: this.getParam,
      }),
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillAccountManagerSidePage', {
        id: row.id,
        resource: 'billing_accounts',
      }, {
        list: this.list,
      })
    },
  },
}
</script>
